type IStatus = '충전' | '출금';
type ICode = 'CHARGE' | 'ORDER_PAY' | 'CANCEL';
/**
 * @author taulmax
 * @date 2024.12.06
 * @description AG GRID TABLE에 들어갈 현황 컴포넌트
 */
const ChargeStatus = ({ status, code }: { status: IStatus; code: ICode }) => {
  let displayText = ''
  if(code === 'CHARGE') {
    displayText = '충전'
  } else if (code === 'ORDER_PAY') {
    displayText = '출금'
  } else if (code === 'CANCEL') {
  displayText = '취소'
}
  return <span className={`grid_status ${code}`}>{displayText}</span>;
};

export default ChargeStatus;
